// src/screens/ForgotPasswordScreen.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen lg:min-h-0 lg:py-12 lg:px-4 bg-gradient-to-br from-customer-teal-light/30 via-white to-customer-accent-light/30 dark:from-app-bg dark:via-app-bg dark:to-app-bg customer-friendly">
      <div className="w-full max-w-md mx-auto">
        <div className="text-center py-8 lg:py-6">
          <h1 className="text-2xl lg:text-3xl font-bold text-app-text-light dark:text-app-text mb-2">
            Reset Password
          </h1>
          <p className="text-app-text-secondary-light dark:text-app-text-secondary">
            {submitted
              ? 'Check your email for a reset link.'
              : "Enter your email and we'll send you a reset link."}
          </p>
        </div>
      </div>

      <div className="flex-1 p-6 lg:p-8 space-y-5 text-sm w-full max-w-md mx-auto bg-white dark:bg-app-bg-secondary rounded-3xl shadow-xl shadow-customer-teal/10 border border-app-border-light/50 dark:border-app-border">
        {submitted ? (
          <div className="text-center space-y-4">
            <div className="text-5xl">📧</div>
            <p className="text-app-text-light dark:text-app-text">
              If that email is registered, you'll receive a password reset link shortly.
            </p>
            <Link
              to="/login"
              className="block w-full py-4 rounded-2xl bg-gradient-to-r from-customer-teal to-customer-teal-hover text-white text-base font-bold text-center shadow-lg shadow-customer-teal/30 hover:shadow-xl transition-all duration-300 hover:scale-[1.02]"
            >
              Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-sm font-medium text-app-text-light dark:text-app-text-secondary">
                Email
              </label>
              <input
                type="email"
                placeholder="your@email.com"
                className="mt-2 w-full px-4 py-3 rounded-2xl bg-app-bg-light dark:bg-app-bg border border-app-input-border-light dark:border-app-input-border text-sm outline-none focus:ring-2 focus:ring-customer-teal/50 focus:border-customer-teal transition-all"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {error && (
              <p className="text-red-500 text-sm">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="mt-4 w-full py-4 rounded-2xl bg-gradient-to-r from-customer-teal to-customer-teal-hover hover:from-customer-teal-hover hover:to-customer-teal-active text-white text-base font-bold shadow-lg shadow-customer-teal/30 hover:shadow-xl transition-all duration-300 hover:scale-[1.02] disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="text-sm text-center text-app-text-secondary-light dark:text-app-text-secondary pt-4 border-t border-app-border-light/50 dark:border-app-border">
              <Link to="/login" className="text-customer-accent font-semibold hover:text-customer-accent-hover transition-colors">
                Back to Login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
